export default __webpack_public_path__ + "static/media/planet-earth-internal.3c465186.svg";